export default __webpack_public_path__ + "static/futuristic-robot-artificial-intelligence-concept-3187c3fb3f3f00dd7709af41d9073911.png";